import { Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./index.less";

type props = {
  isOpen: boolean;
  onClose?: () => void;
  userType: string;
};

const DisableFeatureInfoModalComponent: React.FC<props> = ({ isOpen, onClose, userType }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  const handleGoToEventBtnClick = () => {
    // if (userType === "fan") {
    //   navigate("/p/fan/lives?tab=schedule");
    // }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header px-20">
          <Typography.Text className="bottom-modal-title">{t("important")}</Typography.Text>
        </div>

        <div className="w-full justify-content-center mt-10">
          <Typography.Text className="unlock-link-info-modal-message">{t("disabled-feature-info-modal-message")}</Typography.Text>
        </div>

        <div className="bottom-modal-body mb-40">
          <button className="bottom-modal-button" onClick={handleGoToEventBtnClick}>
            {/* <Typography.Text className="bottom-modal-button-title">{userType === "fan" ? t("go-to-event-btn") : t("confirm-btn")}</Typography.Text> */}
            <Typography.Text className="bottom-modal-button-title">{t("confirm-btn")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisableFeatureInfoModalComponent;
